import URLS from '@/server/urls';
import { UPLOAD } from '@/server/http';

export default async ({
    data = {},
    files = [],
    headers = {},
    onUploadProgress,
}, options = { showError: true }) => {
    const [ content, error, status ] = await UPLOAD(
        URLS.common.uploadTTL,
        data,
        files,
        headers,
        {
            onUploadProgress,
            showError: options.showError || false,
        });
    if (error) return { error, status };
    return content || {};
};
